package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.svg.Svg
import co.maytes.standupbot.dashboard.components.widgets.svg.SvgPath
import co.maytes.standupbot.dashboard.styles.ControlClass
import co.maytes.standupbot.dashboard.styles.Motion
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Space
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.CheckboxInput
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Span

private const val CHECK_PATH = "M20 6 9 17l-5-5"
private const val CHECK_STROKE_WIDTH = "3"

@Composable
internal fun CheckMark() {
    Svg(attrs = {
        attr("viewBox", "0 0 24 24")
        attr("fill", "none")
        attr("stroke", "currentColor")
        attr("stroke-width", CHECK_STROKE_WIDTH)
        attr("stroke-linecap", "round")
        attr("stroke-linejoin", "round")
        attr("aria-hidden", "true")
    }) {
        SvgPath(attrs = {
            attr("d", CHECK_PATH)
            attr("pathLength", Motion.CHECK_DASH_LENGTH.toString())
        })
    }
}

internal fun checkRowLook(metrics: ControlMetrics, disabled: Boolean): Modifier =
    Modifier
        .classNames(ControlClass.CHECK)
        .styleModifier {
            property("min-height", "${metrics.height}")
            property("gap", "${Space.s2}")
            property("cursor", if (disabled) "not-allowed" else "pointer")
            if (disabled) property("opacity", "0.5")
        }

@Composable
fun Checkbox(
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier,
    label: String? = null,
    disabled: Boolean = false,
    size: ControlSize = ControlSize.Md,
    ariaLabel: String? = null,
    invalid: Boolean = false,
) {
    val metrics = size.metrics
    Label(
        attrs = checkRowLook(metrics, disabled).then(modifier).toAttrs(),
    ) {
        CheckboxInput(
            checked = checked,
            attrs = Modifier
                .classNames(ControlClass.CHECK_INPUT)
                .toAttrs {
                    if (disabled) attr("disabled", "")
                    if (invalid) attr("aria-invalid", "true")
                    ariaLabel?.let { attr("aria-label", it) }
                    onInput { if (!disabled) onCheckedChange(it.value) }
                },
        )
        Span(
            attrs = Modifier
                .classNames(ControlClass.CHECK_BOX)
                .width(metrics.boxPx.px)
                .height(metrics.boxPx.px)
                .toAttrs { attr("aria-hidden", "true") },
        ) { CheckMark() }
        label?.let {
            SpanText(
                text = it,
                modifier = Modifier
                    .fontSize(metrics.fontSize)
                    .color(Palette.textPrimary),
            )
        }
    }
}
